import React, { PropTypes } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import CustomSuperTreeview from './CustomSuperTreeView';
export default class Main extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			selected: [],
			tree: [],
			isSeaching: false,
			searchTree: []
		};
	}

	componentDidMount() {
		this.props.actions.getTree().then((e) => {
			this.setState({tree: e});
		});
	}

	handleCheckboxSuperTree(fileId) {
		if ( this.state.selected.indexOf(fileId) === -1 ) { //not in the selected
			const newState = this.state.selected.concat(fileId);
			this.setState({selected: newState});
		} else if (this.state.selected.indexOf(fileId) > -1 ) {
			const i = this.state.selected.indexOf(fileId);			
			const clone = this.state.selected.concat([]);			
			clone.splice(i, 1);
			this.setState({selected: clone});
		}
	}

	getCreateButton(projeto) {

		if (["mariana", "brumadinho"].includes(projeto) === false) throw new Error('Projeto inválido.');
		
		const filesSelected = this.state.selected.length;
		const projectName = projeto === 'mariana' ? 'Mariana' : 'Brumadinho';

		const message = filesSelected === 1 
			? `Criar Documento a partir do arquivo selecionado em ${projectName}`
			: `Criar Documento a partir dos ${filesSelected} arquivos selecionados em ${projectName}`;

		return (
			<span onClick={this.handleExport.bind(this, projeto)}>
				{message}
				&nbsp;&nbsp;
				<i className="fa fa-share ftp-export-button" />
			</span>
		);
	}

	getCreateButtons() {
		const filesSelected = this.state.selected.length;

		if (filesSelected === 0) {
			return (
				<div>
					<span>Selecione arquivos para criar um novo documento.</span>
				</div> 
			);
		}

		return (
			<div>
				{this.getCreateButton("mariana")}
				{this.getCreateButton("brumadinho")}
			</div>
		);
	}

	getHeader() {
		return (
			<div className="ftp-header">
				{this.getCreateButtons()}
			</div>
		);
	}

	handleExport(projeto) {
		if (["mariana", "brumadinho"].includes(projeto) === false) throw new Error('Projeto inválido.');

		this.props.clearForm(); // Guarantees the new document's form is cleared
		const arr = [];
		this.state.selected.map((id) => arr.push(encodeURIComponent(id)));
		const param = arr.join("&");
		const linkToCreateDoc = `/admin/documents/create/${projeto}/${param}`;
		
		window.open(linkToCreateDoc, "_blank");
		// this.props.router.push(linkToCreateDoc);
	}

	getFilterBar() {
		return (
			<form onSubmit={(e) => {
				e.preventDefault();
				e.stopPropagation();
				const tokens = this._filter.value.split(",");
				const terms = [];
				tokens.map((t) => { 
					const parsed = t.trim().toLowerCase();
					if ( parsed !== "" ) terms.push(parsed);
				});				
				if ( terms.length > 0 ) {
					this.props.actions.getSearchTree(terms).then((e) => {
						
						this.setState({isSeaching: true});
						this.setState({searchTree: e});
					});
				} else {
					this.setState({isSeaching: false});
					
				} 
				this.props.actions.setTerms(terms);
				
			}}>
				<div className="row">
					<div className="col-md-5">
						<div className="form-group">
							<input 
								type="text" 
								className="form-control" 						
								placeholder="Digite termos separados por vírgula para filtrar arquivos"								
								ref={(node) => this._filter = node}
								onChange={(e) => { 
									if ( e.target.value === "" ) {			
										this.props.actions.setTerms([]);
										this.setState({isSeaching: false});
									}
								}}							
							/>						
						</div>
					</div>
					<div className="col-md-1">
						<button type="submit" className="btn btn-primary">
							<i className="fa fa-search" /> Filtrar
						</button>					
					</div>				
				</div>
			</form>
		);
	}

	findValues(obj, key) {
		return this.findValuesHelper(obj, key, []);
	}
	
	findValuesHelper(obj, key, list) {
		if (!obj) {
			return list;
		}
		if (obj instanceof Array) {
			for	(var i in obj) {
				try {
					if (this.findValuesHelper(obj[i], key, []).length !== 0) {
						list = this.findValuesHelper(obj[i], key, []);
					}
				} catch (error) {
					
				}
			}
			return list;
		}
		if (obj.id === key) {
			return obj;
		}
		if (obj.children !== null && "children" in obj) {
			if ((typeof obj === "object") && (obj !== null) ) {
				let children = obj.children;
				if (children.length > 0) {
					for (i = 0; i < children.length; i++ ) {
						if (!("children" in children[i])) {
							continue;
						}
						list = this.findValuesHelper(children[i], key, []);
						if (list.length !== 0 ) {
							return list;
						}
					}
				}
				return list;
			}
			if (list.length !== 0 ) {
				return list;
			} else {
				return null;
			}
		}
	
	}

	render () {
		let tree = this.state.isSeaching ? cloneDeep(this.state.searchTree) : cloneDeep(this.state.tree);
		const updatedData = cloneDeep(tree); 
		return (
			<div className="row">
				<div className="col-sm-12">
					<div className="panel panel-default">
						<div className="panel-body">
							<div>
								<h2 style={{textAlign: "center"}}>Explorar Arquivos</h2>
								<hr />
								{this.getFilterBar()}
								{this.getHeader()}					
								<div>
									<CustomSuperTreeview
										handleCheckbox={this.handleCheckbox}
										router={this.props.router}
										downloadFile={this.props.downloadFile}
										
										data={updatedData}
										noChildrenAvailableMessage='Pasta Vazia'
										transitionEnterTimeout={2000}
										keywordKey='path'
										onUpdateCb={(updatedData) => {
											this.setState({tree: updatedData});
										}}
										isCheckable={(node) => {
											if (node.children == null && node.documentID == null) {
												return true;
											} else {
												return false;
											}
										}}
										isDeletable={(node) => {
											return false;
										}}
										getStyleClassCb={(node, depth) => {
											if (node.children == null) {
												return ' super-treeview-node-file';
											} else {
												return ' super-treeview-node-dir';
											}
										}}
										isExpandable={(node) => {
											// disable expand if there is no children
											if (node.children == null) {
												return false;
											} else {
												return true;
											}
										}}
										onExpandToggleCb={(node) => {
											if (node.isExpanded === true) {
												// This will show the loading sign
												node.isChildrenLoading = true;
												let newNode = this.findValues(updatedData, node.id);
												// Remove loading sign
												newNode.isChildrenLoading = false;

												// Make sure node is expanded
												newNode.isExpanded = true;
												this.props.actions.getTree(newNode.id).then((e) => {
													newNode.children = e;
													this.setState({tree: updatedData});
												});
											}
										}}
										// TODO: PROBLEMA COM SELECIONAR CHECKBOX EM BUSCA.
										// O ARQUIVO EH ADICIONADO NA LISTA PARA CRIAR DOCUMENTO
										// MAS A CHECKBOX NAO FICA MARCADA PQ ESSA CHECKBOX AINDA
										// NAO ESTA NA ARVORE PRINCIPAL.
										onCheckToggleCb={(ArrayOfNodes, depth) => {
											ArrayOfNodes.forEach((node, index) => {
												this.handleCheckboxSuperTree(node.hash);
											});
											
										}}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

Main.propTypes = {
	actions: PropTypes.object.isRequired,
	router: PropTypes.object.isRequired,
	clearForm: PropTypes.func.isRequired,
	downloadFile: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/FTP/Main.js